// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'project-plan';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.93 9h1.467m2.935 0H9m2.935 0h5.136m-1.485-1.468L17.072 9l-1.485 1.468m-11.723 0a1.468 1.468 0 1 0 0-2.936 1.468 1.468 0 0 0 0 2.936zm6.604 0a1.468 1.468 0 1 0 0-2.936 1.468 1.468 0 0 0 0 2.936zm0-2.936V4.965m-6.604 8.07v-2.567M12.652.563h-4.37a.75.75 0 0 0-.75.75v2.902c0 .414.336.75.75.75h4.37a.75.75 0 0 0 .75-.75V1.313a.75.75 0 0 0-.75-.75zM6.049 13.035h-4.37a.75.75 0 0 0-.75.75v2.902c0 .415.336.75.75.75h4.37a.75.75 0 0 0 .75-.75v-2.902a.75.75 0 0 0-.75-.75z'
  />
);

export const viewBox = '0 0 18 18';
